import React from "react";
import Marquee from "react-fast-marquee";

const ALLIANCES = [
  { name: "Bitdefender", cat: "Endpoint" },
  { name: "Norton", cat: "Endpoint" },
  { name: "Cisco", cat: "Network" },
  { name: "Jabra", cat: "Collaboration" },
  { name: "Safetica", cat: "Data Protection" },
  { name: "SecuPi", cat: "Data Protection" },
  { name: "GTB Technologies", cat: "Data Protection" },
  { name: "Axidian", cat: "IAM / PAM" },
  { name: "Zaperon", cat: "Zero Trust" },
  { name: "Foxit", cat: "Document Security" },
  { name: "ABBYY", cat: "Document Security" },
];

export default function PartnerBar() {
  return (
    <section data-testid="partner-trust-bar" className="py-14 bg-white border-y border-slate-100">
      <div className="container-cd">
        <div className="text-center mb-8">
          <span className="badge-cd">Technology Alliance Ecosystem</span>
        </div>
        <Marquee gradient gradientColor="#FFFFFF" gradientWidth={120} speed={42} pauseOnHover>
          {ALLIANCES.map((p) => (
            <div
              key={p.name}
              data-testid={`partner-logo-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="mx-4 px-5 py-3 rounded-2xl border border-slate-200 bg-white hover:border-[#3B82F6] hover:shadow-[0_10px_30px_-15px_rgba(59,130,246,0.45)] transition-all group inline-flex items-center gap-3"
            >
              <span className="h-2 w-2 rounded-full bg-cyan-400 group-hover:bg-blue-500 transition-colors" />
              <span className="font-display font-bold text-[#0A1B5E] tracking-tight text-base">{p.name}</span>
              <span className="font-mono-tech text-[9px] tracking-[0.22em] uppercase text-slate-400 border-l border-slate-200 pl-3">{p.cat}</span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
